import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 18 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 4\" id=\"more\"><path d=\"M14 2a2 2 0 104.001-.001A2 2 0 0014 2zm-3 0a2 2 0 10-4.001.001A2 2 0 0011 2zM4 2a2 2 0 10-4.001.001A2 2 0 004 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol